import { render, staticRenderFns } from "./ecologyAchievement.vue?vue&type=template&id=a9a510a0&scoped=true&"
import script from "./ecologyAchievement.vue?vue&type=script&lang=js&"
export * from "./ecologyAchievement.vue?vue&type=script&lang=js&"
import style0 from "./ecologyAchievement.vue?vue&type=style&index=0&id=a9a510a0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9a510a0",
  null
  
)

export default component.exports